import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE, STOCK_SERVER_DOMAIN, USER_FROM } from '../constant'

// 查询商家展位列表  POST  /baoShow/business/list
export const fetchBusinessList = (data) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success'
  //     }, 500)
  //   })
  // })
  return request({
    url: `${STOCK_SERVER_DOMAIN}/baoShow/business/list`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.BSBusinessListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.BSBusinessListResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}

// 商家商品列表     /baoShow/business/productList
export const fetchProductList = (data) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success',
  //       isEnd: true,
  //       productList: [
  //         { appearancePic: '', productName: '东北花色的被盗，炒藕家是不是啥办法煞风景京东方吧', price: 17900, status: 1, pid: 4567 }
  //       ]
  //     }, 500)
  //   })
  // })

  return request({
    url: `${STOCK_SERVER_DOMAIN}/baoShow/business/productList`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.BSBusinessProductListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.BSBusinessProductListResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}

// 商家商品详情   /baoShow/business/productDetail
export const fetchProductDetail = (data) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success',
  //       productInfo: {
  //         pid: '1234',
  //         productName: '古驰Padlock小号双拼色老花翻盖单肩包',
  //         appearancePic: '',
  //         price: 17900,
  //         status: 1
  //       },
  //       businessInfo: {
  //         businessId: '2345',
  //         nickName: 'rookielink',
  //         avatar: ''
  //       }
  //     }, 500)
  //   })
  // })

  return request({
    url: `${STOCK_SERVER_DOMAIN}/baoShow/business/productDetail`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.BSBusinessProductDetailRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.BSBusinessProductDetailResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}

// 创建订单
export const orderCreate = (data) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success'
  //     }, 500)
  //   })
  // })
  return request({
    url: `${STOCK_SERVER_DOMAIN}/baoShow/order/gen`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.BSOrderGenRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.BSOrderGenResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}

// 订单支付接口请求   /baoShow/order/pay
export const fetchPay = (data) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       errorCode: 0,
  //       errorMsg: 'Success'
  //     }, 500)
  //   })
  // })
  return request({
    url: `${STOCK_SERVER_DOMAIN}/baoShow/order/pay`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.BSOrderPayRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.BSOrderPayResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}

// 微信浏览器支付(JSAPI支付) POST /baoShow/order/payOnWxBrowser
export const payOnWxBrowser = (params) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/baoShow/order/payOnWxBrowser`,
    method: 'POST',
    data: params
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.BSOrderPayOnWxBrowserRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.BSOrderPayOnWxBrowserResponse',
    httpAddress: 'stock',
    ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}

// 在获取网页授权access_token时获取openid POST /account/webPageOpenid
export const webPageOpenid = ({ code }) => {
  return request({
    url: `${SERVER_DOMAIN}/account/webPageOpenid`,
    method: 'POST',
    data: { code }
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWebPageOpenidRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWebPageOpenidResponse',
    ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.BAOZHAN
  })
}